/* eslint-disable no-shadow */
export enum NavigationType {
  ORGANIZATION = 'organization',
  STORE = 'store', // sucursal
  CEAL = 'ceal', // Centro de almacenamiento
  STORE_DRAFT = 'storeDraft', // Store Draft
}
